import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import styled from 'styled-components'

import Link from '../../global/Link'

const StyledPrimaryButton = styled(PrimaryButton)`
  display: block;
  width: 100%;
  max-width: 344px;
  margin: 0 auto;
`

export const AccountRouteNotFound: React.VFC = () => (
  <>
    <Helmet title="404: Not Found" />
    <h3>Page not found.</h3>
    <p>The page you&#39;re looking for doesn&#39;t exist.</p>
    <StyledPrimaryButton as={Link} to="/account/">
      Return to Dashboard
    </StyledPrimaryButton>
  </>
)
